import angular from "angular";
import "angular-i18n/angular-locale_pt-br";

import applicationController from "./controllers/application-controller";
import marketablesSearchController from "./controllers/marketables-search-controller";
import marketablesShowController from "./controllers/marketables-show-controller";
import marketablesTopMediaController from "./controllers/marketables-top-media-controller";
import metricsFilterController from "./controllers/metrics-filter-controller";
import metricsReportController from "./controllers/metrics-report-controller";
import agendaSearchController from "./controllers/agenda-search-controller";
import ngAnimate from "angular-animate";
import ngTouch from "angular-touch";

angular.module("App", [
  ngAnimate,
  ngTouch,
  applicationController,
  marketablesTopMediaController,
  marketablesShowController,
  metricsFilterController,
  metricsReportController,
  marketablesSearchController,
  agendaSearchController,
]);



// WEBPACK FOOTER //
// ./app/web/packs/angular/app.js